import { createStore } from "../../../../../utils/states";
import { PaymentMethodState } from "../types";

const initialState: PaymentMethodState = {
  method: "online",
  selectedPayments: [],
  paymentType: "Bank Transfer",
  referenceNumber: "",
  dateReceived: "",
  markAsPaid: false,
  manualEntryNotes: "",
  manualEntryTransactionId: "",
};

const { useState: usePaymentMethodState, useActions: useSetPaymentMethod } = createStore<PaymentMethodState>(initialState);

export { usePaymentMethodState, useSetPaymentMethod };
